import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { FaEye } from "react-icons/fa"
import {
  Button,
  Card,
  CardBody,
  ModalBody,
  ModalHeader,
  Table,
  Modal,
} from "reactstrap"
import Swal from "sweetalert2"
import { fetchData } from "utils/Common_api_functions"

const PayrollHistory = () => {
  const [alldata, setalldata] = useState([])
  const [loading, setLoading] = useState(false)

  const [selectedPayroll, setSelectedPayroll] = useState([])
  const [viewModal, setViewModal] = useState(false)

  useEffect(() => {
    getHistory()
  }, [])

  async function getHistory() {
    const APIdata = await fetchData(setLoading, "payroll/sheets")
    if (APIdata?.success) {
      setalldata(APIdata?.payrollSheets)
    } else {
      setalldata([])
      Swal.fire({
        icon: "error",
        title: "Error Fetching Payroll Sheets",
        text: APIdata?.response?.data?.message,
      })
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb
        title="Dashboard"
        breadcrumbItem="Payroll History"
        description="Check the Histroy of Generated Payroll of Employees based on daily logs"
      />

      <Card>
        <CardBody>
          <Table>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Payroll Frequency</th>
                <th>Total Employees</th>
                <th>Status</th>
                <th>Approved By</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {alldata?.length === 0 && (
                <tr>
                  <td colSpan={8} className="text-center">
                    No Data Found{" "}
                  </td>
                </tr>
              )}
              {alldata?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{moment(item?.fromDate).format("DD/MM/YYYY")}</td>
                  <td>{moment(item?.toDate).format("DD/MM/YYYY")}</td>
                  <td>{item?.frequency}</td>
                  <td>{JSON.parse(item?.data).length}</td>
                  <td>
                    {item?.status ? (
                      <span className="badge bg-success p-2">Approved</span>
                    ) : (
                      <span className="badge bg-info">Generated</span>
                    )}
                  </td>

                  <td>{item?.approver?.name}</td>
                  <td>
                    <Button
                      color="primary"
                      onClick={() => {
                        setSelectedPayroll(JSON.parse(item?.data)),
                          setViewModal(true)
                      }}
                    >
                      <FaEye />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
      <Modal isOpen={viewModal} size="xl" centered>
        <ModalHeader toggle={() => setViewModal(false)}>
          <h5 className="mb-0">Payroll Data</h5>
        </ModalHeader>
        <ModalBody>
          <Table className="bg-white mt-3" responsive bordered>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Surname</th>
                <th>Time Sheet - Hours worked </th>
                <th>Hours - Location</th>
                <th>Email Address</th>
                <th>Payment Frequency</th>
              </tr>
            </thead>
            <tbody>
              {selectedPayroll?.length === 0 && (
                <tr>
                  <td colSpan={7} className="text-center">
                    No Data Found{" "}
                  </td>
                </tr>
              )}

              {selectedPayroll?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.employeeName?.split(" ")[0]}</td>
                    <td>{item?.employeeName?.split(" ").slice(1).join(" ")}</td>
                    <td>{Math.round(Number(item?.totalHours || 0))}</td>
                    <td>
                      {item?.locationBreakdown?.length > 0
                        ? item.locationBreakdown.map((loc, i) => {
                            const hrs = parseFloat(loc.hours) || 0
                            return (
                              <div key={i} style={{ lineHeight: "1.8" }}>
                                {Math.round(hrs)} hrs - {loc.locationName}
                              </div>
                            )
                          })
                        : ""}
                    </td>
                    <td>{item?.email}</td>
                    <td>{item?.paymentFrequency}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default PayrollHistory
